import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, Quote } from 'lucide-react';
import { getTestimonyBySlug } from '../data/testimonies';
export function TestimonyDetailPage() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const testimony = slug ? getTestimonyBySlug(slug) : undefined;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);
  if (!testimony) {
    return <main className="flex-grow pt-32 pb-24 bg-ivory text-center px-6" data-id="element-567">
        <h1 className="text-4xl font-display font-bold text-midnight mb-6" data-id="element-568">
          Testimony not found
        </h1>
        <Link to="/impact" className="inline-flex items-center gap-2 text-gold font-bold tracking-wide hover:text-midnight transition-colors" data-id="element-569">
          <ArrowLeft className="w-5 h-5" data-id="element-570" /> Back to Testimonies
        </Link>
      </main>;
  }
  return <main className="flex-grow pt-24" data-id="element-571">
      <div className="bg-midnight text-ivory py-24 relative overflow-hidden" data-id="element-572">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-midnight-light to-transparent opacity-50 pointer-events-none" data-id="element-573" />

        <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-574">
          <Link to="/impact" className="inline-flex items-center gap-2 text-ivory/70 hover:text-gold transition-colors text-sm font-bold tracking-widest uppercase mb-12" data-id="element-575">
            <ArrowLeft className="w-4 h-4" data-id="element-576" /> All Testimonies
          </Link>

          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full text-xs font-bold tracking-widest uppercase mb-6 text-gold" data-id="element-577">
            Testimony
          </div>

          <h1 className="text-4xl md:text-6xl font-display font-bold leading-tight tracking-tighter mb-8" data-id="element-578">
            {testimony.title}
          </h1>

          <p className="text-ivory/70 text-sm font-bold uppercase tracking-wider" data-id="element-579">
            — {testimony.name}
          </p>
        </div>
      </div>

      <section className="py-32 bg-ivory text-midnight" data-id="element-580">
        <div className="max-w-3xl mx-auto px-6" data-id="element-581">
          <article className="bg-white p-8 md:p-16 rounded-[3rem] shadow-xl border-2 border-midnight/5 relative overflow-hidden" data-id="element-582">
            <Quote className="absolute -top-10 -right-10 w-48 h-48 text-gold opacity-10 pointer-events-none" data-id="element-583" />

            <div className="w-16 h-2 bg-gold rounded-full mb-12 relative z-10" data-id="element-584" />

            <div className="font-medium leading-relaxed text-lg md:text-xl text-charcoal/80 space-y-8 relative z-10" data-id="element-585">
              {testimony.paragraphs.map((p, i) => <p key={i} data-id="element-586">{p}</p>)}
            </div>

            <div className="mt-16 pt-8 border-t-2 border-midnight/5 relative z-10" data-id="element-587">
              <p className="font-display font-bold text-2xl text-midnight" data-id="element-588">
                {testimony.name}
              </p>
            </div>
          </article>

          <div className="mt-16 text-center" data-id="element-589">
            <Link to="/impact" className="inline-flex items-center gap-2 text-midnight font-bold tracking-wide hover:text-gold transition-colors" data-id="element-590">
              <ArrowLeft className="w-5 h-5" data-id="element-591" /> Back to all testimonies
            </Link>
          </div>
        </div>
      </section>
    </main>;
}